export const ICON_SEARCH_MODES = {
    USER_ACTION: 'user_action',
    BOARD_CREATE: 'board_create',
};
